import { useComputedColorScheme, useMantineColorScheme } from '@mantine/core';
import { AnimatePresence, motion } from 'framer-motion';
import { Moon, Sun } from 'lucide-react';

/**
 * ThemeToggle — light/dark switch for the top bar. Drives Mantine's color
 * scheme (persisted), which in turn flips the Tailwind CSS-variable tokens via
 * data-mantine-color-scheme. Animated icon swap.
 */
export function ThemeToggle({ className }: { className?: string }) {
  const { setColorScheme } = useMantineColorScheme();
  const scheme = useComputedColorScheme('light', { getInitialValueInEffect: true });
  const dark = scheme === 'dark';

  return (
    <button
      type="button"
      aria-label={dark ? 'Switch to light theme' : 'Switch to dark theme'}
      onClick={() => setColorScheme(dark ? 'light' : 'dark')}
      className={`relative flex size-8 cursor-pointer items-center justify-center overflow-hidden rounded-lg border border-bd bg-card text-txt-2 transition-colors duration-150 hover:border-bd-bright hover:text-txt ${className ?? ''}`}
    >
      <AnimatePresence initial={false} mode="wait">
        <motion.span
          key={dark ? 'moon' : 'sun'}
          initial={{ y: 12, opacity: 0, rotate: -30 }}
          animate={{ y: 0, opacity: 1, rotate: 0 }}
          exit={{ y: -12, opacity: 0, rotate: 30 }}
          transition={{ duration: 0.18 }}
          className="flex items-center justify-center"
        >
          {dark ? <Moon className="size-4" /> : <Sun className="size-4" />}
        </motion.span>
      </AnimatePresence>
    </button>
  );
}
